/**
 * @generated SignedSource<<0f28f504a94806b6b1fddad81f29de1e>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type scenariosSection_AtlassianConversationAssistantAgent$data = {
  readonly edges: ReadonlyArray<{
    readonly node: {
      readonly id: string;
      readonly " $fragmentSpreads": FragmentRefs<"scenarioModal_AtlassianConversationAssistantAgent">;
    } | null;
  }> | null;
  readonly " $fragmentType": "scenariosSection_AtlassianConversationAssistantAgent";
};
export type scenariosSection_AtlassianConversationAssistantAgent$key = {
  readonly " $data"?: scenariosSection_AtlassianConversationAssistantAgent$data;
  readonly " $fragmentSpreads": FragmentRefs<"scenariosSection_AtlassianConversationAssistantAgent">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "name": "scenariosSection_AtlassianConversationAssistantAgent",
  "selections": [
    {
      "concreteType": "AgentStudioScenariosEdge",
      "kind": "LinkedField",
      "name": "edges",
      "plural": true,
      "selections": [
        {
          "kind": "LinkedField",
          "name": "node",
          "plural": false,
          "selections": [
            {
              "kind": "ScalarField",
              "name": "id"
            },
            {
              "kind": "FragmentSpread",
              "name": "scenarioModal_AtlassianConversationAssistantAgent"
            }
          ]
        }
      ]
    }
  ],
  "type": "AgentStudioScenariosResult"
};

(node as any).hash = "891908316ab8569db263bd2966577830";

export default node;
